import { useQuery } from '@tanstack/react-query';
import { useApi, type ChannexRevisionHoldList } from '@/shared/api';

export const REVISION_HOLDS_KEY = ['channex', 'quarantined-revisions'] as const;
const LIMIT = 50;
const WAITING_REFETCH_MS = 15_000;

/**
 * Solange eine Revision wartet, entscheidet der Server bald selbst über sie — die Liste fragt
 * dann alle 15 s nach, sonst nicht (Hintergrund-Tabs fragen nie, TanStack-Standard). Ist die
 * automatische Wiederholung ausgeschaltet, entscheidet niemand von selbst.
 */
export function refetchWhileWaiting(list: ChannexRevisionHoldList | undefined) {
  return list?.automaticRetry && list.awaitingTotal > 0 ? WAITING_REFETCH_MS : false;
}

/** `poll`: zusätzlich regelmäßig nachfragen – für den Zähler im Gerüst, der auf jeder Seite steht. */
export function useRevisionHolds(enabled = true, poll?: number) {
  const api = useApi();
  return useQuery({
    queryKey: [...REVISION_HOLDS_KEY, LIMIT],
    queryFn: () => api.channex.quarantinedRevisions(LIMIT),
    enabled,
    staleTime: 60_000,
    refetchInterval: (query) => refetchWhileWaiting(query.state.data) || poll || false,
    refetchOnWindowFocus: poll ? true : undefined,
  });
}
